module.exports = __webpack_public_path__ + "img/6.a1c1db01.jpg";